(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["trophy-variant-connection"] && !Shopify.designMode) return;
  try {
    (() => {
  const data = document.getElementById('trophy-variant-data');
  if (!data) return;
  const variants = JSON.parse(data.textContent);
  const product = document.querySelector('product-info[data-product-id]');
  if (!product) return;
  const normalize = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  const colorAliases = { blue: 'dark blue', pink: 'dark pink' };
  const styleAliases = {
    'red penguin': 'penguin - red',
    'white snowman': 'snowman - knit',
    'green reindeer': 'reindeer-green/knit',
    'red gingerbread': 'gingerbread - knit',
    'green stripe elf': 'elf - green',
    'green lights': 'lights - knit',
    'red striped santa': 'santa - red knit',
    'white w/ red snowflake': 'snowflake - white',
    'red holly': 'holly - knit',
    'red w/ white snowflake': 'snowflake-red/knit',
    'green w/ white snowflake': 'snowflake-green/knit',
    'maroon/green argyle': 'argyle - red',
    'blue snowman': 'snowman-blue/knit',
    'blue w/ burgundy snowman': 'snowman - maroon/knit'
  };
  const styleField = { '8740822941950': 'Sweater Choice', '9008872554750': 'Topper Choice' }[product.dataset.productId];
  const titleAliases = {
    'create your own title': 'custom title',
    'most yatzees': 'most yahtzees',
    'dice king': 'dice queen/dice king',
    'dice queen': 'dice queen/dice king'
  };
  const valueFor = (value, index) => {
    const key = normalize(value);
    return (index === 0 ? (styleField ? styleAliases : colorAliases) : titleAliases)[key] || key;
  };
  let scheduled = false;
  let requested = '';
  let requestTime = 0;
  const inputsFor = name => [...product.querySelectorAll('.tpo_option-set-container input[type="radio"]')]
    .filter(input => input.name.endsWith(',' + name));
  const selected = inputs => inputs.find(input => input.checked);
  function state() {
    const colors = inputsFor(styleField || 'Dice Color');
    const titles = inputsFor('Trophy Title');
    const color = selected(colors);
    const title = selected(titles);
    const variant = color && title && variants.find(item =>
      valueFor(color.value, 0) === normalize(item.options[0]) &&
      (item.options.length === 1 || valueFor(title.value, 1) === normalize(item.options[1])));
    return { colors, titles, color, title, variant };
  }
  function purchaseState(allowed, soldOut) {
    product.classList.toggle('trophy-options-pending', !allowed);
    const button = product.querySelector('product-form button[name="add"]');
    if (!button) return;
    if (button.disabled === allowed) button.disabled = !allowed;
    const label = button.querySelector('span');
    const text = soldOut ? window.variantStrings.soldOut : window.variantStrings.addToCart;
    if (label && !button.classList.contains('loading') && label.textContent.trim() !== text) label.textContent = text;
  }
  function sync() {
    scheduled = false;
    const current = state();
    const picker = product.querySelector('variant-selects');
    if (!current.colors.length || !current.titles.length) return;
    const mapped = variants.every(item => item.options.length === 1) || current.titles.every(input => variants.some(item => valueFor(input.value, 1) === normalize(item.options[1])));
    if (!mapped) {
      product.classList.remove('trophy-options-connected');
      purchaseState(false, false);
      return;
    }
    product.classList.add('trophy-options-connected');
    current.colors.forEach(input => {
      const available = variants.some(item => item.available && valueFor(input.value, 0) === normalize(item.options[0]));
      if (input.disabled === available) input.disabled = !available;
      const label = input.closest('label');
      if (label) label.classList.toggle('trophy-unavailable-choice', !available);
    });
    if (!current.variant) {
      purchaseState(false, false);
      return;
    }
    const formInput = product.querySelector('product-form input[name="id"]');
    if (!picker) {
      product.querySelectorAll('form input[name="id"]').forEach(input => {
        if (input.value !== String(current.variant.id)) {
          input.value = String(current.variant.id);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      purchaseState(current.variant.available && !!formInput, !current.variant.available);
      return;
    }
    let resolved = null;
    try { resolved = JSON.parse(picker.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch {}
    const matches = String(current.variant.id) === formInput?.value && String(current.variant.id) === String(resolved?.id);
    if (matches) {
      requested = '';
      purchaseState(current.variant.available, !current.variant.available);
      return;
    }
    purchaseState(false, !current.variant.available);
    const key = String(current.variant.id);
    if (requested === key && Date.now() - requestTime < 10000) return;
    const groups = [...picker.querySelectorAll('fieldset')];
    const targets = current.variant.options.map((value, index) =>
      [...(groups[index]?.querySelectorAll('input[type="radio"]') || [])].find(input => normalize(input.value) === normalize(value)));
    if (targets.some(input => !input) || targets.length !== current.variant.options.length) return;
    targets.forEach(input => { input.checked = true; });
    requested = key;
    requestTime = Date.now();
    targets[targets.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(sync, 0);
  }
  product.addEventListener('change', schedule);
  product.addEventListener('input', schedule);
  const observer = new MutationObserver(schedule);
  observer.observe(product, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] });
  product.addEventListener('click', event => {
    if (!event.target.closest('button[name="add"], .shopify-payment-button')) return;
    if (product.classList.contains('trophy-options-pending')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      schedule();
    }
  }, true);
  product.addEventListener('submit', event => {
    const current = state();
    if (!current.colors.length && !current.titles.length) return;
    const id = event.target.querySelector('input[name="id"]')?.value;
    if (!current.variant?.available || id !== String(current.variant.id) || product.classList.contains('trophy-options-pending')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      schedule();
    }
  }, true);
  schedule();
})();
(() => {
  const product = document.querySelector('product-info[data-product-id]');
  const titleFields = {
    '8740822941950': ['text-box-6302238', 'Choose your Title'],
    '9157440504062': ['text-box-6317853', 'Create your own Title'],
    '9157440635134': ['text-box-6317901', 'Create your own Title'],
    '9008872554750': ['text-box-6317368', 'Choose your own title']
  };
  const titleField = product && titleFields[product.dataset.productId];
  if (!titleField) return;
  product.classList.add('trophy-preview-layout');
  const header = document.querySelector('.section-header');
  function measureHeader() {
    const height = header ? header.getBoundingClientRect().height : 0;
    product.style.setProperty('--trophy-preview-top', `${height + 8}px`);
  }
  measureHeader();
  if (header) new ResizeObserver(measureHeader).observe(header);
  function clearCustomTitle(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const radio = target.matches('input[type="radio"]')
      ? target : target.closest('label')?.querySelector('input[type="radio"]');
    if (!radio || !radio.name.endsWith(',Trophy Title') || radio.value === titleField[1]) return;
    const input = document.getElementById(titleField[0]);
    if (!input || !input.value) return;
    const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, '');
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  product.addEventListener('pointerdown', clearCustomTitle, true);
  product.addEventListener('keydown', event => {
    if (event.key === ' ' || event.key === 'Enter') clearCustomTitle(event);
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
